// 标准代码工具类
import LanguageApi from '@/api/dict/api-language'
import OriginApi from '@/api/dict/api-origin'
import MealsApi from '@/api/dict/api-mealrequest'
import SpecialApi from '@/api/dict/api-specialrequest'
import TravelDocApi from '@/api/dict/api-traveldoc'
import EthnicitiesApi from '@/api/dict/api-ethnicities'


function listToDictArray(list) {
  let dictList = null
  if (list && list.length > 0) {
    dictList = []
    for (let i=0; i<list.length; i++) {
      const listItem = list[i]
      dictList.push({
        code: listItem.id,
        enName: listItem.enName,
        twName: listItem.twName,
        lgCode: listItem.code,
        ifOther: listItem.ifOther,
        documentCode: listItem.countryCode
      })
    }
  }
  return dictList
}
// ----------------------------------- 族群 ----------------------------------
const Ethnicities = {}

async function getEthnicitiesDict () {
  if(!Ethnicities.dict) {
    const res = await EthnicitiesApi.list()
    Ethnicities.dict = listToDictArray(res.data)
  }
  return Ethnicities.dict
}

Ethnicities.getDict = getEthnicitiesDict

// ----------------------------------- 语言 ----------------------------------
const Language = {}

async function getLanguageByCode (code) {
  if(!Language.dict) {
    const res = await LanguageApi.list()
    Language.dict = listToDictArray(res.data)
  }
  return Language.dict.filter(item => {
    return item.code == code
  })[0]
}

async function getLanguageDict () {
  if(!Language.dict) {
    const res = await LanguageApi.list()
    Language.dict = listToDictArray(res.data)
  }
  return Language.dict
}

Language.getByCode = getLanguageByCode
Language.getDict = getLanguageDict

// ----------------------------------- Background ----------------------------------
const Background = {}

async function getBackgroundByCode (code) {
  if(!Background.dict) {
    const res = await OriginApi.list()
    Background.dict = listToDictArray(res.data)
  }
  return Background.dict.filter(item => {
    return item.code == code
  })[0]
}

async function getBackgroundDict () {
  if(!Background.dict) {
    const res = await OriginApi.list()
    Background.dict = listToDictArray(res.data)
  }
  return Background.dict
}

Background.getByCode = getBackgroundByCode
Background.getDict = getBackgroundDict

// ----------------------------------- 餐食 ----------------------------------
const Meals = {}

async function getMealsByCode (code) {
  if(!Meals.dict) {
    const res = await MealsApi.list()
    Meals.dict = listToDictArray(res.data)
  }
  return Meals.dict.filter(item => {
    return item.code == code
  })[0]
}

async function getMealsDict () {
  if(!Meals.dict) {
    const res = await MealsApi.list()
    Meals.dict = listToDictArray(res.data)
  }
  return Meals.dict
}

Meals.getByCode = getMealsByCode
Meals.getDict = getMealsDict

// ----------------------------------- 特别要求 ----------------------------------
const Special = {}

async function getSpecialByCode (code) {
  if(!Special.dict) {
    const res = await SpecialApi.list()
    Special.dict = listToDictArray(res.data)
  }
  return Special.dict.filter(item => {
    return item.code == code
  })[0]
}

async function getSpecialDict () {
  if(!Special.dict) {
    const res = await SpecialApi.list()
    Special.dict = listToDictArray(res.data)
  }
  return Special.dict
}

Special.getByCode = getSpecialByCode
Special.getDict = getSpecialDict

// ----------------------------------- 护照类别 ----------------------------------
const TravelDoc = {}
async function getTravelDocByCode (code) {
  if(!TravelDoc.dict) {
    const res = await TravelDocApi.list()
    TravelDoc.dict = listToDictArray(res.data)
  }
  return TravelDoc.dict.filter(item => {
    return item.code == code
  })[0]
}

async function getTravelDocDict () {
  if(!TravelDoc.dict) {
    const res = await TravelDocApi.list()
    TravelDoc.dict = listToDictArray(res.data)
  }
  return TravelDoc.dict
}

TravelDoc.getByCode = getTravelDocByCode
TravelDoc.getDict = getTravelDocDict

export {
  Ethnicities,
  Language,
  Background,
  Meals,
  Special,
  TravelDoc
}
